@let session = this.selectedSession();

@if (sessionLoading()) {
  <app-header />

  <ion-content>
    <div class="alfred-client-container">
      <ion-card>
        <ion-card-content>
          <ion-skeleton-text [animated]="true" />
          <ion-skeleton-text [animated]="true" />
          <ion-skeleton-text [animated]="true" />
        </ion-card-content>
      </ion-card>
    </div>
  </ion-content>
} @else if (session) {
  <app-header />

  <ion-content>
    <div class="alfred-client-container">
      <ion-card>
        <ion-card-content>
          <lib-alfred-client
            [showCloseBtn]="false"
            [sessionId]="session.id"
            (finished)="navigateToHome()"
            (onCancelClick)="navigateToHome()"
          />
        </ion-card-content>
      </ion-card>
    </div>
  </ion-content>
} @else {
  <ion-content>
    <div class="verifying-link-container">
      <ion-grid>
        <ion-row>
          <ion-col
            size="12"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-card>
              <ion-card-content class="ion-text-center">
                <img
                  src="assets/icon/logo.svg"
                  alt="Logo"
                  class="logo ion-margin-bottom"
                />
                <ng-container>
                  <h1>Ongeldige link gebruikt</h1>
                  De door jou gebruikte link is niet geldig. Controleer de link
                  en probeer het opnieuw.
                </ng-container>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>
}
